import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { credentialTypesEnums, renderClientName } from 'utils';
import { SelectAutocompletePagination } from 'components';
import { renderStaffName } from './constants';

export const staffCredentialReport = () => {
    return {
        title: 'Staff Credentials Expiration Report',
        url: '/reports/staff/credential/expiration',
        list: [
            {
                type: 'select',
                name: 'staffStatus',
                label: 'Staff Status',
                selectList: [
                    { name: 'Active', id: 'ACTIVE' },
                    { name: 'Inactive', id: 'INACTIVE' },
                ],
                renderValue: (option) => option?.name,
            },
            { type: 'date', name: 'credentialExpirationDate', label: 'Credential Expiration Date' },
            {
                type: 'select',
                name: 'credentialType',
                label: 'Credential Type',
                selectList: credentialTypesEnums,
                renderValue: (option) => option?.name,
            },
        ],
    };
};
export const staffPaycodeReport = () => {
    return {
        title: 'Staff Paycodes Snapshot',
        url: '/reports/staff/paycode',
        list: [
            {
                type: 'selectWidthPagination',
                name: 'staff',
                label: 'Staff',
                reqType: 'staff',
                renderValue: (option) => renderStaffName(option),
            },
            // {
            //     type: 'select',
            //     name: 'staff',
            //     label: 'Staff',
            //     loadType: 'GET_ADMINS',
            //     renderValue: (option) => renderStaffName(option)
            // },
            {
                type: 'select',
                name: 'staffStatus',
                label: 'Staff Status',
                selectList: [
                    { name: 'Active', id: 'ACTIVE' },
                    { name: 'Inactive', id: 'INACTIVE' },
                ],
                renderValue: (option) => option?.name,
            },
        ],
    };
};

export const staffDetailReport = () => {
    return {
        title: 'Staff Info Details',
        url: '/reports/staff/details',
        list: [
            {
                type: 'selectMultipleWidthPagination',
                name: 'staffs',
                label: 'Staff',
                reqType: 'staff',
                renderValue: (option) => renderStaffName(option),
            },
            // {
            //     type: 'selectMultiple',
            //     name: 'staffs',
            //     label: 'Staff',
            //     loadType: 'GET_ADMINS',
            //     renderValue: (option) => renderStaffName(option)
            // },
            {
                type: 'select',
                name: 'status',
                label: 'Staff Status',
                selectList: [
                    { name: 'Active', id: 'ACTIVE' },
                    { name: 'Inactive', id: 'INACTIVE' },
                ],
                renderValue: (option) => option?.name,
            },
        ],
    };
};

export const apptSessionNotes = () => {
    return {
        title: 'Appt Session Notes',
        url: '/reports/appt/session-notes',
        list: [
            {
                type: 'selectWidthPagination',
                name: 'client',
                label: 'Client',
                reqType: 'client',
                renderValue: (option) => renderClientName(option),
            },
            {
                type: 'dos',
                startDate: 'startDate',
                endDate: 'endDate',
                startLabel: 'Start Date',
                endLabel: 'End Date',
                required: true,
            },
        ],
    };
};

export const supervisionReport = () => {
    return {
        title: 'Supervision Report',
        url: '/reports/staff/supervision',
        list: [
            {
                type: 'select',
                name: 'type',
                label: 'Type',
                required: true,
                selectList: [
                    { name: 'Supervisor', id: 'SUPERVISOR' },
                    { name: 'Supervisee', id: 'SUPERVISEE' },
                ],
                renderValue: (option) => option?.name,
            },
            {
                type: 'customRow',
                renderRow: (control, watch, setValue) => {
                    const typeValue = watch('type');
                    const isSupervisor = typeValue === 'SUPERVISOR';
                    const label = isSupervisor ? 'Supervisor' : 'Supervisee';
                    const fieldName = isSupervisor ? 'supervisor' : 'supervisee';
                    return (
                        <SelectAutocompletePagination
                            key={fieldName}
                            uiType={'fromForm'}
                            title={label}
                            name={fieldName}
                            handleSelect={(e) => setValue(fieldName, e?.target?.value)}
                            defaultValue={watch(fieldName)}
                            renderValue={(i) => renderStaffName(i)}
                            type={'staff'}
                        />
                    );
                },
            },
            {
                type: 'dos',
                startDate: 'startDate',
                endDate: 'endDate',
                startLabel: 'Start Date',
                endLabel: 'End Date',
                required: true,
            },
        ],
    };
};

export const staffReportEnums = (company) => [
    {
        id: uuidv4(),
        name: 'Staff Credentials Expiration Report',
        description: 'Staff credentials nearing expiration to ensure compliance.',
        generateInfo: staffCredentialReport(),
    },
    {
        id: uuidv4(),
        name: 'Staff Paycodes Snapshot',
        description: 'Provides detailed information about staff pay codes, including rates, status, and dates.',
        generateInfo: staffPaycodeReport(),
    },
    {
        id: uuidv4(),
        name: 'Staff Info Details',
        description: 'Staff profiles with personal, contact, employment, and credential details.',
        generateInfo: staffDetailReport(),
    },
    {
        id: uuidv4(),
        name: 'Supervision Report',
        description: 'Supervision session details grouped by supervisor or supervisee with hour subtotals.',
        generateInfo: supervisionReport(),
    },
];
